import React, {FC} from "react";
import {IGetAllLocalizationLanguagesBodyRes} from "@evennt-tech/api-v2-external";

const LanguageName: FC<{language: IGetAllLocalizationLanguagesBodyRes}> = ({
  language,
}) => (
  <>
    {language.name}
    <span style={{textTransform: "capitalize"}}>
      {" "}
      ({language.base ? "UK" : language.originalName})
    </span>
  </>
);

export default LanguageName;
